import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopCarrierReport extends Layout {
    checkboxPageBreak: Checkbox;
    etCarrierCategories: ExcludableTextbox;
    etDispatchers: ExcludableTextbox;
    etOperationsUsers: ExcludableTextbox;
    etSalespersons: ExcludableTextbox;
    sourceTopCarrier: DataSource;
    switchComparePeriods: Switch;
    switchIncludeFuelSurcharge: Switch;
    switchIncludeRemainingCharges: Switch;
    switchPrintMonthlyTotals: Switch;
    textboxCarrierToPrint: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
    textboxMinimumMoves: Textbox;
    textboxRankBy: Textbox;
    textboxShipDate: Textbox;
    textboxStartTwo: Textbox;
}
